import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["active", "children", "hovered", "icon", "minimized", "onClick", "pointySide"];
import { FloatingActionButton, FloatingActionButtonProvider } from 'foundations-components/transitional/components/FloatingActionButton';
import Beaker from '../icons/Beaker';
import { HoverProvider } from 'foundations-components/transitional/components/HoverProvider';
import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BeakerContainer = styled.div.withConfig({
  displayName: "BetaButton__BeakerContainer",
  componentId: "sc-1mo5xcg-0"
})(["height:54px;left:0;position:absolute;top:-24px;width:20px;"]);
const InnerButton = styled.span.withConfig({
  displayName: "BetaButton__InnerButton",
  componentId: "sc-1mo5xcg-1"
})(["padding-left:", ";position:relative;"], ({
  $icon
}) => $icon === 'beaker' ? '26px' : 0);
export const BetaButton = _ref => {
  let {
      active,
      children,
      hovered,
      icon = 'beaker',
      minimized = false,
      onClick,
      pointySide
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  // @bend-expect trellis-tokenized custom padding for beaker icon
  return /*#__PURE__*/_jsx(HoverProvider, {
    hovered: hovered,
    children: ({
      hovered: isHovered
    }) => /*#__PURE__*/_jsx(FloatingActionButtonProvider, {
      isBetaButton: true,
      children: /*#__PURE__*/_jsx(FloatingActionButton, Object.assign({
        active: active,
        hovered: isHovered,
        minimized: minimized,
        onClick: onClick,
        pointySide: pointySide
      }, rest, {
        children: /*#__PURE__*/_jsxs(InnerButton, {
          $icon: icon,
          children: [icon === 'beaker' && /*#__PURE__*/_jsx(BeakerContainer, {
            children: /*#__PURE__*/_jsx(Beaker, {})
          }), children]
        })
      }))
    })
  });
};

// Temporary for backwards compatibility
export default BetaButton;